import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/styles/index.css";
import { AuthProvider } from "@/app/AuthContext";
import { App } from "@/app/App";

const container = document.querySelector<HTMLDivElement>("#root");
if (container === null) {
  throw new Error("#root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    {/* Router outermost: the auth context needs to be able to navigate, not the other way round. */}
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
